<app-print-templates-container #container [title]="'Print Templates'">
  <app-tab-bar
    #tabController
    [tabs]="viewModel.tabs$ | async"
    (selectedTab)="container.tabSelected($event)"></app-tab-bar>
</app-print-templates-container>
